import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { ProductCategoryCreateForm } from '@/features/product/components/product-category-form'

export const Route = createFileRoute('/_app/product/category/create')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/product', 'Produk'],
					['/product/category', 'Kategori'],
					[Route.fullPath, 'Tambah kategori'],
				]}
			/>
			<PageCard>
				<PageCard.Header title="Tambah Kategori" />
				<ProductCategoryCreateForm />
			</PageCard>
		</PageLayout>
	)
}
